import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_REQUEST_APPOINTMENT_RESCHEDULE } from "../../action-types/actions";

import i18n from "../../i18n";
export const requestAppointmentRescheduleReducer = createAsyncThunk(
  ACTIONS_REQUEST_APPOINTMENT_RESCHEDULE.request,
  async ({ appointmentId }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.requestAppointmentReschedule}/${appointmentId}/request-reschedule`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        toast.success(response?.data?.message || i18n.t("toast.rescheduleRequestedSuccessfully"));
        return response.data;
      } else {
        toast.error(response?.data?.message || i18n.t("toast.rescheduleRequestFailed"));
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorRequestingReschedule");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
